// extracted by mini-css-extract-plugin
export default {"container":"BfYndzJ0sIPGqrAP25lk","title":"cof02z8dB8XcOeNMgAhK","label":"FWOlysKJOCjFep6tdQZi","table":"tbue9E4m3GAP4Sx_pwtW"};